export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
  prompt: 'select_account'
};